export default {
  mounted() {
    const element = this.el
    const duration = parseInt(this.el.dataset.magicTyperDuration || "1000")
    const highlightClass = this.el.dataset.highlightClass
    const fullText = element.innerHTML.trim()
    const step = Math.round(duration / fullText.length)
    const flashElement = document.getElementById('auto-titled-flash')

    let index = 0

    let currentText = '' // Initialize an empty string to accumulate the text

    element.classList.add(highlightClass)

    const typeCharacter = () => {
      const chunkSize = 1
      const nextIndex = Math.min(index + chunkSize, fullText.length)

      currentText += fullText.substring(index, nextIndex) // Add the next chunk of text to the current text
      element.innerHTML = currentText // Update the element's content with the accumulated text

      index = nextIndex // Update the index for the next iteration

      if (index < fullText.length) {
        setTimeout(typeCharacter, step)
      } else {
        element.classList.remove(highlightClass)
        element.classList.add('text-primary')
        setTimeout(showFlash, 1000)
      }
    }

    const showFlash = () => {
      flashElement.classList.remove('opacity-0')
      setTimeout(() => {
        flashElement.classList.add('opacity-0')
      }, 6000)
    }

    const key = `auto-title-${this.el.id}`
    if (!localStorage.getItem(key)) {
      element.innerHTML = '&nbsp;' // Clear the element's content, but don't collapse it
      typeCharacter()
    }
  },
}
